import { Button } from "antd";
import React from "react";
interface RamadanButtonProps {
  title: string;
  onClick?: () => void;
  icon?: React.ReactNode;
  classname? : string;
}
const RamadanButton = ({ icon, title, classname, ...props }: RamadanButtonProps) => {
  return (
    <Button {...props} className={`ghaith--ramadan-button ${classname || ""}`} icon={icon}>
      {title}
    </Button>
  );
};

export default RamadanButton;
